export enum CampaignTypes {
  POTENTIALS = 0,
  // { id: 1, label: 'Campaign Type 1' },
  // { id: 2, label: 'Campaign Type 2' },
}

export const CAMPAIGN_TYPES = [
  { id: CampaignTypes.POTENTIALS.toString(), name: 'potentials' },
  // { id: 1, label: 'Campaign Type 1' },
  // { id: 2, label: 'Campaign Type 2' },
]
